import { gql } from '@apollo/client';

export const DISMISS_CART_BANNER = gql`
	mutation DismissCartBanner($cartId: String!) {
		dismissCartBanner(cartId: $cartId)
	}
`;